import { useMemo } from 'react'
import WebsiteTag from '../../../components/ui/websiteTag/WebsiteTag'
import CompanyLogo from '../../../components/CompanyLogo'
import { Typography, Divider, Skeleton } from '@mui/material'
import ShowMoreText from 'react-show-more-text'
import styles from './ReportPanelCompanyInfo.module.scss'

const ReportPanelCompanyInfo = ({data}) => {
    const dictionary = useMemo(() => [
        {name: 'Revenue', value:'revenue'},
        {name: 'Employess', value:'employees'},
        {name: 'Type', value:'type'},
        {name: 'Founded', value:'founded'},
        {name: 'HQ', value:'headquarters'},
    ], [])

    const infoComponent = useMemo(() => {
        if(!data) {return []}
        let componentsArray = dictionary.flatMap(
            ({name, value}) => ([
                <Box key={name} title={name} info={data[value]}/>, 
                <Divider orientation='vertical' key={`${name}-divider`}/>
            ]))
        componentsArray.splice(-1,1)
        return componentsArray
    },[data, dictionary]) 

    return (
        <div className={styles['company-info-container']}>
            <div>
                <div className={styles['header']}>
                    <CompanyLogo image={data?.image} size={32}/>
                    {data ? <Typography variant='h1'>{data?.companyName}</Typography> : <Skeleton width='100%' height='50px'/>}
                    <WebsiteTag website={data?.website} companyName={data?.companyName}/>
                </div>
                { data 
                    ? <ShowMoreText>
                        <Typography> {data?.description}</Typography>
                    </ShowMoreText>
                    : <Skeleton width='100%' height='80px'/>
                }
            </div>
            <div>
                <div className={styles['info-box']}> 
                    {data ? infoComponent : <Skeleton className={styles['info-box-skeleton']} width='100%' height='115px'/>} 
                </div>
            </div>
        </div>
    )
}

const Box = ({title, info = ''}) => {
    const {value, date} = typeof info !== 'string' ? info : {value: info}

    return (
        <div className={styles['box']}>
            <Typography color='textSecondary'>{title}</Typography>
            <Typography variant='h2'>{value || '-'}</Typography>
            {date && <Typography color='textSecondary'>{date}</Typography>}
        </div>
    )
}

export default ReportPanelCompanyInfo